<template>
  <span :class="'text-' + fontColor">{{ user.username }}</span>
</template>

<script>
export default {
  name: "Username",
  props: {
    user: {
      required: true
    }
  },
  computed: {
    fontColor() {
      if (this.user.role === "admin") return "blue-7"
      if (this.user.role === "super-moderator") return "yellow-7"
      if (
        this.$route.params.channel !== null &&
        this.user.moderatable_channels.indexOf(this.$route.params.channel) !== -1
      )
        return "orange-7"
      return "grey-7"
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
